//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';

export default {
  name: 'DpColourLegend',
  props: {
    minimumValue: { type: Number, default: null },
    maximumValue: { type: Number, default: null },
    colours: { type: Array, default: null },
  },
  data() {
    return {
      showTooltip: false,
      tooltipText: 'test',
      tooltipLeft: 0,
    };
  },
  computed: {
    startColour() {
      return this.colours ? this.colours[0] : null;
    },
    endColour() {
      return this.colours ? this.colours[this.colours.length - 1] : null;
    },
    isHsl() {
      const { startColour } = this;
      if (!startColour) return false;
      return startColour.substring(0, 3) === 'hsl';
    },
    startLabel() {
      if (Number.isNaN(this.minimumValue)) return null;
      return _.round(this.minimumValue, 1);
    },
    endLabel() {
      if (Number.isNaN(this.maximumValue)) return null;
      return _.round(this.maximumValue, 1);
    },
    gradient() {
      if (this.isHsl) {
        const steps = 5;
        const lines = [];

        const startHue = parseInt(this.startColour.substring(4), 10) || 0;
        const endHue = parseInt(this.endColour.substring(4), 10) || 0;
        const diff = endHue - startHue;

        for (let i = 0; i < steps + 1; i += 1) {
          const stepPercent = i * Math.ceil(100 / steps);
          const hue = startHue + ((stepPercent / 100) * diff);
          lines.push(`hsl(${hue}, 80%, 50%) ${stepPercent}%`);
        }

        return `linear-gradient(to right, ${lines.join(',')})`;
      }

      return `linear-gradient(to right, ${this.startColour} 0%, ${this.endColour} 100%)`;
    },
  },
  methods: {
    updateTooltip(e) {
      const {
        left: anchorLeft,
        width: anchorWidth,
      } = this.$refs.anchor.getBoundingClientRect();
      const { clientX: mouseX } = e;
      const { width: tooltipWidth } = this.$refs.tooltip.getBoundingClientRect();

      const delta = Math.max(mouseX - anchorLeft, 0);
      const leftPosition = Math.min(delta, anchorWidth);
      this.tooltipLeft = Math.min(leftPosition - (tooltipWidth / 2), anchorWidth - tooltipWidth);

      const percent = delta / anchorWidth;
      const { minimumValue, maximumValue } = this;

      const range = maximumValue - minimumValue;
      const hoveredValue = minimumValue + (percent * range);
      this.tooltipText = `${_.round(hoveredValue, 1)}`;
    },
  },
};
